const it = {
  // Navbar
  "nav.visione": "La Visione",
  "nav.territorio": "Il Territorio",
  "nav.servizi": "Servizi",
  "nav.immobili": "Immobili",
  "nav.contatti": "Contatti",
  "nav.progetto": "Il Progetto",

  // Hero
  "hero.tagline": "Ogni borgo ha una storia da custodire.\nOgni casa può diventare l'inizio di una nuova vita.",
  "hero.cta": "Scopri gli Immobili",
  "hero.scroll": "Scorri",

  // Visione
  "visione.overline": "La MIA visione",
  "visione.title": "Non vendiamo case,\nRaccontiamo territori",
  "visione.text": "Le Marche custodiscono un patrimonio silenzioso e straordinario: borghi medievali dove il tempo scorre lento, piazze di pietra illuminate dal sole di settembre, vicoli che profumano di storia millenaria. Tra il mare dell'Adriatico e i monti Sibillini, queste colline dorate custodiscono qualità di vita che il mondo moderno ha dimenticato. Noi non vendiamo immobili. Apriamo porte su territori da scoprire, su ritmi da ritrovare, su radici da costruire.",
  "visione.ines.name": "Ines Felicity Di Nallo",
  "visione.ines.role": "Agente Immobiliare Abilitata",
  "visione.ines.bio": "Abilitazione CCIAA Ancona (ottobre 2025) — Laurea in Economia, Università di Bologna — Ex Responsabile Meeting & Events, G Hotel Ancona — Esperta di digital marketing e relazioni internazionali. Trilingue italiano, inglese e spagnolo.",
  "visione.ines.badge.license": "CCIAA Ancona",
  "visione.ines.badge.unibo": "Laurea Economia",
  "visione.ines.badge.languages": "IT · EN · ES",

  // Territorio
  "territorio.overline": "Il territorio",
  "territorio.title": "Le Marche: dove il tempo\nrallenta e la bellezza è di casa",
  "territorio.text": "Un territorio che abbraccia il mare, il monte e la collina in pochi chilometri. La Riviera del Conero con le sue acque cristalline, i borghi medievali come Castelfidardo custodi di artigianato e musica, le colline coltivate a vite e ulivo, la cucina che racconta secoli di sapienza contadina. Le Marche sono un segreto ancora ben custodito, il luogo dove chi cerca bellezza autentica trova una patria.",
  "territorio.caption1": "Scalinata Storica - Corinaldo",
  "territorio.caption2": "Riviera del Conero",
  "territorio.caption3": "Rocca Roveresca - Mondavio",
  "territorio.caption4": "Colline Marchigiane",
  "territorio.keyword1": "mare",
  "territorio.keyword2": "borghi storici",
  "territorio.keyword3": "enogastronomia",

  // Servizi
  "servizi.overline": "Cosa facciamo",
  "servizi.0.title": "Raccontiamo il Territorio",
  "servizi.0.desc": "Borghi storici, aziende agricole e strutture ricettive locali non sono semplici immobili: sono storie da custodire e valorizzare. Raccontiamo ogni realtà con cura, mettendo in luce l'identità autentica del luogo, la sua storia e il suo potenziale, per attrarre chi cerca non solo una casa, ma un modo di vivere.",
  "servizi.0.step1": "Ascolto della storia e dell'identità del luogo",
  "servizi.0.step2": "Valorizzazione di borghi, aziende agricole e agriturismi",
  "servizi.0.step3": "Narrazione autentica per strutture ricettive locali",
  "servizi.0.step4": "Posizionamento sul mercato con un racconto che distingue",
  "servizi.title": "Un servizio su misura,\nnon un listino prezzi.",
  "servizi.1.title": "Compravendita in Borghi Storici",
  "servizi.1.desc": "Selezione accurata di immobili in borghi storici delle Marche: rustici, case coloniche, palazzi d'epoca, abitazioni con carattere e anima.",
  "servizi.2.title": "Assistenza Internazionale",
  "servizi.2.desc": "Consulenza completa in italiano, inglese e spagnolo per acquirenti esteri. Dalla ricerca alla firma, ogni fase accompagnata nella tua lingua.",
  "servizi.3.title": "Fotografia & Tour Virtuali",
  "servizi.3.desc": "Reportage fotografici professionali e tour virtuali 360° per valorizzare ogni proprietà con la qualità visiva che merita.",
  "servizi.4.title": "Rete di Professionisti",
  "servizi.4.desc": "Accesso a una rete selezionata di architetti, interior designer, geometri, notai e legali specializzati in compravendite immobiliari.",

  // Immobili
  "immobili.overline": "In vetrina",
  "immobili.title": "Proprietà selezionate",
  "immobili.cta": "Richiedi informazioni",
  "immobili.badge1": "Castelfidardo",
  "immobili.badge2": "Riviera del Conero",
  "immobili.badge3": "Colline di Osimo",
  "immobili.prop1.title": "Casa colonica restaurata",
  "immobili.prop1.type": "Casale · 240 mq · Vista colline",
  "immobili.prop2.title": "Dimora storica in borgo",
  "immobili.prop2.type": "Palazzo d'epoca · 380 mq · Centro storico",
  "immobili.prop3.title": "Villa panoramica sul Conero",
  "immobili.prop3.type": "Villa · 320 mq · Vista mare",

  // Per Chi
  "perchi.overline": "Per chi è questo",
  "perchi.title": "Ogni storia merita il\nsuo territorio.",
  "perchi.1.title": "Famiglie e giovani professionisti",
  "perchi.1.desc": "Chi cerca una qualità di vita autentica, spazi per crescere, borghi dove i ritmi umani sono ancora possibili e la bellezza è quotidiana.",
  "perchi.2.title": "Acquirenti internazionali",
  "perchi.2.desc": "Europei, anglosassoni, sudamericani affascinati dall'Italia vera: un accompagnamento completo dalla ricerca alla consegna delle chiavi, nella tua lingua.",
  "perchi.3.title": "Investitori immobiliari",
  "perchi.3.desc": "Chi punta su immobili di pregio, agriturismi, strutture ricettive in un territorio con straordinario potenziale turistico ancora da valorizzare.",

  // Contatti
  "contatti.overline": "Parliamo",
  "contatti.title": "Ogni grande storia\ninizia con una conversazione.",
  "contatti.name": "Nome",
  "contatti.email": "Email",
  "contatti.phone": "Telefono",
  "contatti.message": "Messaggio",
  "contatti.message.placeholder": "Raccontaci cosa stai cercando...",
  "contatti.submit": "Invia il messaggio",
  "contatti.success": "Messaggio inviato! Ti risponderemo presto.",
  "contatti.error": "Si è verificato un errore. Riprova.",
  "contatti.sede": "Castelfidardo (AN)",
  "contatti.lingue": "Italiano · English · Español",
  "contatti.instagram": "@felicity.dinallo_",

  // Footer FSE+
  "footer.copyright": "© 2026 Marche Casa. Tutti i diritti riservati.",
  "footer.privacy": "Privacy Policy",
  "footer.progetto": "Il Progetto",
  "footer.fse.title": "Progetto co-finanziato dall'Unione Europea",
  "footer.fse.text": "Progetto co-finanziato dall\'Unione Europea — PR FSE+ 2021/27 Regione Marche — DGR n. 977 del 24/06/2024",
  "footer.fse.logo1": "Coesione Italia 2021-2027",
  "footer.fse.logo2": "Cofinanziato dall'Unione Europea",
  "footer.fse.logo3": "Repubblica Italiana",
  "footer.fse.logo4": "Regione Marche",

  // Nav new pages
  "nav.borghi": "Borghi",
  "nav.blog": "Blog",

  // Footer new
  "footer.tagline": "Agente immobiliare abilitata CCIAA Ancona.\nBorghi storici delle Marche · IT · EN · ES",
  "footer.guida": "Guida Acquisto",

  // Borghi section (home)
  "borghi.cta": "Scopri il borgo",
  "borghi.viewAll": "Vedi tutti i borghi",

  // Borghi page
  "borghi.overline": "I borghi delle Marche",
  "borghi.title": "Ogni borgo è un mondo\nda scoprire.",
  "borghi.intro": "Le Marche sono un arcipelago di borghi medievali, ciascuno con la propria identità, la propria storia, il proprio carattere. Dal mare del Conero alle colline dell'entroterra, ogni paese custodisce un patrimonio unico di architettura, artigianato e sapori autentici.",
  "borghi.filter.tutti": "Tutti",
  "borghi.filter.mare": "Mare",
  "borghi.filter.collina": "Collina",
  "borghi.filter.entroterra": "Entroterra",
  "borghi.zona.mare": "Mare",
  "borghi.zona.collina": "Collina",
  "borghi.zona.entroterra": "Entroterra",
  "borghi.scopri": "Scopri il borgo",
  "borghi.immobili.overline": "Proprietà selezionate",
  "borghi.immobili.title": "Un immobile per ogni borgo.",
  "borghi.immobili.vedi": "Vedi tutti gli immobili",
  "borghi.cta.overline": "Inizia la ricerca",
  "borghi.cta.title": "Hai un borgo nel cuore?",
  "borghi.cta.text": "Raccontaci dove vorresti vivere e ti aiutiamo a trovare la casa giusta in quel territorio.",
  "borghi.cta.btn": "Contattaci",

  // Borgo detail
  "borgo.storia": "Storia e identità",
  "borgo.storia.title": "Scopri {{name}}",
  "borgo.immobili.overline": "Immobili in questo borgo",
  "borgo.immobili.title": "Proprietà a {{name}}",
  "borgo.cta.title": "Vuoi vivere a {{name}}?",
  "borgo.cta.text": "Contattaci per scoprire le opportunità immobiliari in questo borgo e nei dintorni.",
  "borgo.cta.btn": "Richiedi informazioni",

  // Immobili page
  "immobili.page.overline": "Catalogo immobili",
  "immobili.page.title": "Proprietà selezionate\nnei borghi marchigiani.",
  "immobili.filter.tipologia": "Tipologia",
  "immobili.filter.target": "Per chi",
  "immobili.filter.borgo": "Borgo",
  "immobili.filter.tutti": "Tutti",
  "immobili.filter.rustico": "Rustico",
  "immobili.filter.palazzo": "Palazzo",
  "immobili.filter.villa": "Villa",
  "immobili.filter.casale": "Casale",
  "immobili.filter.prima-casa": "Prima casa",
  "immobili.filter.investimento": "Investimento",
  "immobili.filter.turistico": "Turistico",
  "immobili.risultati": "proprietà trovate",
  "immobili.locali": "locali",
  "immobili.dettagli": "Vedi dettagli",
  "immobili.nessun": "Nessun immobile trovato con i filtri selezionati.",

  // Immobile detail
  "immobile.mq": "Superficie",
  "immobile.locali": "Locali",
  "immobile.piano": "Piano",
  "immobile.stato": "Stato",
  "immobile.descrizione": "Descrizione",
  "immobile.form.title": "Richiedi informazioni",
  "immobile.form.subtitle": "Compila il form e ti risponderemo entro 24 ore.",
  "immobile.altri.title": "Altri immobili a {{borgo}}",

  // Blog
  "blog.overline": "Storie e approfondimenti",
  "blog.title": "Il blog di\nMarche Casa.",
  "blog.filter.tutti": "Tutti",
  "blog.leggi": "Leggi l'articolo",
  "blog.correlati": "Articoli correlati",
  "blog.borghi.correlati": "Borghi correlati",
  "blog.sidebar.cta.title": "Cerchi casa nelle Marche?",
  "blog.sidebar.cta.text": "Siamo qui per aiutarti a trovare la proprietà perfetta nel borgo dei tuoi sogni.",
  "blog.sidebar.cta.btn": "Contattaci",

  // Servizi page
  "servizi.page.title": "Un servizio su misura\nper ogni storia.",
  "servizi.page.intro": "Non siamo un'agenzia tradizionale. Ogni cliente è una storia unica, ogni immobile è un territorio da raccontare. Il nostro approccio è personale, attento, trilingue.",
  "servizi.1.step1": "Analisi delle esigenze e del budget",
  "servizi.1.step2": "Selezione accurata degli immobili",
  "servizi.1.step3": "Visite guidate nei borghi",
  "servizi.1.step4": "Supporto fino alla firma del rogito",
  "servizi.2.step1": "Consulenza iniziale in lingua",
  "servizi.2.step2": "Assistenza burocratica (codice fiscale, conto corrente)",
  "servizi.2.step3": "Coordinamento con notaio e legale",
  "servizi.2.step4": "Supporto post-acquisto",
  "servizi.3.step1": "Sopralluogo e pianificazione del servizio fotografico",
  "servizi.3.step2": "Shooting professionale con luce naturale",
  "servizi.3.step3": "Tour virtuale 360° con tecnologia immersiva",
  "servizi.3.step4": "Consegna materiali ottimizzati per web e stampa",
  "servizi.4.step1": "Valutazione delle necessità specifiche",
  "servizi.4.step2": "Selezione del professionista più adatto",
  "servizi.4.step3": "Coordinamento e supervisione",
  "servizi.4.step4": "Follow-up e garanzia di qualità",
  "servizi.cta": "Richiedi questo servizio",
  "servizi.processo.overline": "Come lavoriamo",
  "servizi.processo.title": "Il nostro processo in 5 passi",
  "servizi.step1.title": "Ascolto",
  "servizi.step1.desc": "Capire le tue esigenze, il tuo stile di vita, il tuo budget",
  "servizi.step2.title": "Ricerca",
  "servizi.step2.desc": "Selezione accurata degli immobili più adatti",
  "servizi.step3.title": "Visita",
  "servizi.step3.desc": "Tour guidati nei borghi con approfondimento del territorio",
  "servizi.step4.title": "Proposta",
  "servizi.step4.desc": "Supporto nella trattativa e nella proposta d'acquisto",
  "servizi.step5.title": "Rogito",
  "servizi.step5.desc": "Assistenza completa fino alla consegna delle chiavi",
  "servizi.cta.title": "Pronto a iniziare?",
  "servizi.cta.text": "Contattaci per una consulenza gratuita e senza impegno. Siamo qui per ascoltarti.",
  "servizi.cta.btn": "Prenota una consulenza",

  // Contatti page
  "contatti.page.title": "Ogni grande storia\ninizia con una conversazione.",
  "contatti.info.overline": "Dove siamo",
  "contatti.info.title": "Parliamo del tuo\nprogetto di vita.",
  "contatti.info.text": "Che tu stia cercando la prima casa, un investimento o stia pianificando il tuo trasferimento nelle Marche, siamo qui per ascoltarti. Rispondiamo in italiano, inglese e spagnolo.",
  "contatti.sede.label": "Sede",
  "contatti.lingue.label": "Lingue",
  "contatti.abilitazione.label": "Abilitazione",
  "contatti.borgo.label": "Come mi hai trovato?",
  "contatti.borgo.placeholder": "Seleziona un borgo...",
  "contatti.borgo.altro": "Altro / Non so ancora",
  "contatti.form.title": "Vuoi vendere casa? Scrivimi",
  "contatti.form.subtitle": "Rispondiamo entro 24 ore.",
  "contatti.success.title": "Messaggio inviato!",

  // Move to Marche
  "move.hero.title": "Your new life\nstarts here.",
  "move.hero.subtitle": "Le Marche: qualità della vita autentica, prezzi accessibili, borghi medievali, mare e montagna. Tutto in un'unica regione.",
  "move.hero.cta": "Scopri come trasferirsi",
  "move.why.overline": "Perché le Marche",
  "move.why.title": "La regione italiana\npiù autentica.",
  "move.why.text": "Le Marche offrono tutto ciò che si cerca in Italia — bellezza, storia, gastronomia, mare — senza la folla e i prezzi di Toscana o Umbria. Una regione ancora autentica, dove la qualità della vita è straordinaria e le opportunità immobiliari sono ancora accessibili.",
  "move.stat.costo": "Costo medio vita mensile",
  "move.stat.costa": "Di costa adriatica",
  "move.stat.roma": "Da Roma in treno",
  "move.stat.aeroporti": "Aeroporti internazionali vicini",
  "move.process.overline": "Come funziona",
  "move.process.title": "Il processo di acquisto\nper non residenti.",
  "move.step1.title": "Codice Fiscale",
  "move.step1.desc": "Il primo passo è ottenere il codice fiscale italiano, necessario per qualsiasi transazione. Si ottiene presso il Consolato italiano nel tuo paese o direttamente all'Agenzia delle Entrate in Italia.",
  "move.step2.title": "Conto corrente",
  "move.step2.desc": "Aprire un conto corrente italiano semplifica i pagamenti. Non è obbligatorio ma fortemente consigliato. Alcune banche permettono l'apertura anche da non residenti.",
  "move.step3.title": "Proposta d'acquisto",
  "move.step3.desc": "Una volta trovato l'immobile, si firma una proposta d'acquisto con caparra confirmatoria. Questo vincola entrambe le parti alla vendita.",
  "move.step4.title": "Compromesso",
  "move.step4.desc": "Il contratto preliminare (compromesso) definisce tutti i termini della vendita. Si versa una seconda caparra, solitamente il 10-20% del prezzo.",
  "move.step5.title": "Rogito notarile",
  "move.step5.desc": "L'atto definitivo di compravendita si firma davanti al notaio. Il saldo del prezzo viene versato e le chiavi vengono consegnate.",
  "move.faq.overline": "Domande frequenti",
  "move.faq.title": "FAQ per acquirenti esteri",
  "move.faq.1.q": "Gli stranieri possono comprare casa in Italia?",
  "move.faq.1.a": "Sì, i cittadini UE possono acquistare liberamente. I cittadini extra-UE possono acquistare se esiste un accordo di reciprocità tra l'Italia e il loro paese (quasi sempre presente).",
  "move.faq.2.q": "Quanto costa comprare casa nelle Marche?",
  "move.faq.2.a": "I prezzi variano molto: da €80.000 per un rustico da ristrutturare a €700.000+ per ville di lusso. La media per un immobile abitabile è tra €150.000 e €350.000.",
  "move.faq.3.q": "Quali tasse si pagano sull'acquisto?",
  "move.faq.3.a": "Per prima casa: imposta di registro 2% del valore catastale. Per seconda casa o non residenti: 9%. Più imposte ipotecaria e catastale fisse (€50 ciascuna).",
  "move.faq.4.q": "È necessario il notaio?",
  "move.faq.4.a": "Sì, in Italia il rogito notarile è obbligatorio per il trasferimento di proprietà immobiliare. Il notaio è scelto dall'acquirente e le sue spese sono a carico dell'acquirente.",
  "move.faq.5.q": "Posso ottenere un mutuo come straniero?",
  "move.faq.5.a": "Sì, le banche italiane concedono mutui anche a non residenti, solitamente fino al 60-70% del valore dell'immobile. Sono richiesti reddito dimostrabile e buon merito creditizio.",
  "move.cta.title": "Pronto a fare il grande passo?",
  "move.cta.text": "Contattaci per una consulenza gratuita. Ti guidiamo in ogni fase del processo, nella tua lingua.",
  "move.cta.btn": "Inizia il tuo percorso",

  // Guida acquisto
  "guida.overline": "Guida completa",
  "guida.title": "Comprare casa nelle Marche:\nla guida completa.",
  "guida.intro": "Dalla ricerca dell'immobile alla firma del rogito: tutto quello che devi sapere per acquistare casa nei borghi marchigiani, passo dopo passo. Una guida pensata sia per italiani che per acquirenti internazionali.",
  "guida.step": "Step",
  "guida.step1.title": "Ricerca dell'immobile",
  "guida.step1.text": "La ricerca inizia definendo chiaramente le proprie esigenze: tipologia di immobile, zona geografica, budget, destinazione d'uso. Nelle Marche è fondamentale visitare i borghi di persona per capire quale territorio risuona con il proprio stile di vita. Ogni borgo ha un'anima diversa.",
  "guida.step2.title": "Visita e valutazione",
  "guida.step2.text": "La visita è il momento più importante. Oltre all'immobile, valutiamo il borgo, i servizi, la comunità locale, le infrastrutture. Per gli immobili da ristrutturare, è essenziale un sopralluogo con un tecnico per stimare i costi di intervento.",
  "guida.step3.title": "Proposta d'acquisto",
  "guida.step3.text": "Una volta trovato l'immobile giusto, si presenta una proposta d'acquisto scritta con caparra confirmatoria (solitamente 5-10% del prezzo). Se accettata dal venditore, entrambe le parti sono vincolate. Se il venditore recede, restituisce il doppio della caparra.",
  "guida.step4.title": "Rogito notarile",
  "guida.step4.text": "Il rogito è l'atto definitivo di compravendita, firmato davanti al notaio. Il notaio verifica la regolarità dell'immobile, calcola le imposte dovute e registra il trasferimento di proprietà. Il saldo del prezzo viene versato in questa sede.",
  "guida.step5.title": "Consegna delle chiavi",
  "guida.step5.text": "Dopo la firma del rogito, le chiavi vengono consegnate e l'immobile è ufficialmente tuo. Seguono le pratiche di voltura delle utenze (luce, gas, acqua) e, se necessario, l'iscrizione all'anagrafe del comune.",
  "guida.sidebar.cta.title": "Hai bisogno di aiuto?",
  "guida.sidebar.cta.text": "Siamo qui per guidarti in ogni fase del processo di acquisto.",
  "guida.sidebar.cta.btn": "Contattaci",
  "guida.sidebar.move.text": "Sei straniero e vuoi comprare casa nelle Marche? Leggi la nostra guida dedicata.",
  "guida.sidebar.move.btn": "Move to Marche",
  "guida.indice": "Indice",

  // Progetto Modal
  "progetto.title": "Il Progetto",

  // Partner page
  "partner.hero.overline": "LA NOSTRA RETE",
  "partner.hero.title": "Professionisti Partner",
  "partner.intro": "Comprare casa in Italia, soprattutto se si arriva da un altro Paese, significa affidarsi a persone che conoscono davvero il territorio, le regole e i dettagli tecnici. Per questo Discovering Marche lavora fianco a fianco con professionisti selezionati, in grado di garantire trasparenza in ogni fase della trattativa e qualità in ogni fase della realizzazione.",
  "partner.partner1.overline": "Studio Legale e Notarile",
  "partner.partner1.title": "Studio Spanò & Marchionni — Avvocato e Notaio, Fermo",
  "partner.partner1.desc": "Lo Studio Spanò & Marchionni di Fermo affianca Discovering Marche nella parte legale e notarile di ogni negoziazione immobiliare. Due figure chiave — l'avvocato e il notaio — che garantiscono la piena trasparenza dell'operazione: verifica della documentazione, tutela delle parti, gestione dei passaggi legali fino al rogito. Un supporto essenziale soprattutto per la clientela estera, che spesso non conosce l'iter di acquisto in Italia.",
  "partner.partner1.bullet1": "Verifica di conformità catastale e urbanistica",
  "partner.partner1.bullet2": "Assistenza in ogni fase della trattativa, dalla proposta al rogito",
  "partner.partner1.bullet3": "Massima trasparenza per acquirenti italiani ed esteri",
  "partner.partner2.overline": "Impresa Edile",
  "partner.partner2.title": "Sparviero Srl — Impresa di Costruzioni, Camerano (AN)",
  "partner.partner2.details": "Impresa attiva dal 2000, certificazione ISO 9001, qualificazione SOA RINA Cat. OG1 - Classe III. Esperienza consolidata in bioedilizia, ristrutturazioni integrali, restauro di edifici storici, ville indipendenti ed edilizia civile e industriale.",
  "partner.partner2.desc": "Sparviero Srl è l'impresa di costruzioni che garantisce la qualità realizzativa dei progetti seguiti da Discovering Marche. Ha realizzato interventi di altissimo livello in strutture ricettive — tra cui Numana Blu S.P.A. a Marcelli — e ha collaborato alla realizzazione di complessi immobiliari di pregio orientati all'efficientamento energetico e alla sostenibilità ambientale.",
  "partner.partner2.bullet1": "Ristrutturazioni integrali di rustici, casali e case d'epoca",
  "partner.partner2.bullet2": "Nuove realizzazioni e ville indipendenti \"chiavi in mano\"",
  "partner.partner2.bullet3": "Bioedilizia, efficientamento energetico e materiali eco-sostenibili",
  "partner.trust.overline": "Perché una rete di partner",
  "partner.trust.title": "La forza di un team affiatato.",
  "partner.trust.trasparenza.title": "Trasparenza",
  "partner.trust.trasparenza.desc": "Nessuna sorpresa legale o burocratica: ogni passaggio è verificato e condiviso.",
  "partner.trust.qualita.title": "Qualità costruttiva",
  "partner.trust.qualita.desc": "Interventi certificati e verificabili, con standard di eccellenza artigianale.",
  "partner.trust.referente.title": "Un solo referente",
  "partner.trust.referente.desc": "Discovering Marche coordina ogni figura per te, senza deleghe confuse.",
  "partner.trust.multilingua.title": "Assistenza multilingua",
  "partner.trust.multilingua.desc": "Il team segue anche la clientela internazionale in italiano, inglese e spagnolo.",
  "partner.cta.title": "Vuoi sapere come lavoriamo con i nostri partner sul tuo progetto?",
  "partner.cta.text": "Raccontaci il tuo progetto e ti spiegheremo come la nostra rete di professionisti può accompagnarti in ogni fase.",
  "partner.cta.btn": "Parlaci del tuo progetto",

  "progetto.sintesi.title": "Sintesi del Progetto",
  "progetto.sintesi.text": "Il progetto Marche Casa nasce nell\'ambito del Programma Regionale FSE+ 2021-2027 della Regione Marche, con l\'obiettivo di sostenere l\'inserimento lavorativo e l\'autoimprenditorialità nei settori ad alto potenziale economico, tra cui il mercato immobiliare e il turismo esperienziale nei borghi storici.",
  "progetto.obiettivi.title": "Obiettivi",
  "progetto.obiettivi.text": "Promuovere l\'accesso al lavoro autonomo in settori strategici per il territorio marchigiano. Valorizzare il patrimonio immobiliare storico e rurale come leva di sviluppo economico sostenibile. Favorire l\'integrazione tra turismo, cultura e mercato immobiliare nelle aree interne e costiere della regione.",
  "progetto.risultati.title": "Risultati Attesi",
  "progetto.risultati.text": "Creazione di un\'impresa individuale nel settore immobiliare specializzata in borghi storici marchigiani. Sviluppo di un servizio bilingue per attrarre acquirenti nazionali e internazionali. Contribuire alla rivitalizzazione dei borghi marchigiani attraverso la mediazione immobiliare qualificata.",
  "progetto.close": "Chiudi",
};

export default it;
